const headerSearch = () => {
  const body = document.querySelector('body');
  const searchToggleBtn = document.querySelector('.icon-item-search > a');
  const searchModule = document.querySelector('.dd-search');
  const searchIpt = document.getElementById('header-search-input');
  const hiddenClass = 'hide';

  const showSearchModule = () => {
    searchToggleBtn.setAttribute('aria-expanded', 'true');
    searchModule.classList.remove(hiddenClass);
    searchIpt.focus();
  };

  const hideSearchModule = () => {
    searchToggleBtn.setAttribute('aria-expanded', 'false');
    searchModule.classList.add(hiddenClass);
    searchIpt.blur();
    searchIpt.value = '';
  };

  const closeMenuOnBodyClick = (event) => {
    if (event.target.closest('.dd-search, .icon-item-search') === null) {
      hideSearchModule();
    }
  };

  const toggleSearchModule = (event) => {
    event.preventDefault();
    const isExpanded = searchToggleBtn.getAttribute('aria-expanded');
    if (isExpanded === 'true') {
      hideSearchModule();
      return;
    }
    showSearchModule();
  };

  if (searchToggleBtn) {
    searchToggleBtn.addEventListener('click', toggleSearchModule);
    searchToggleBtn.setAttribute('aria-haspopup', 'true');
    searchToggleBtn.setAttribute('aria-expanded', 'false');
    body.addEventListener('click', closeMenuOnBodyClick);
  }
};

export default headerSearch;
